import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import Link from 'react-router/lib/Link';

import { COMMUNITIES, PUBLIC_PROFILE } from '../../../../constants/routes';
import { CommunityCard } from '../../Components/CommunityCard';
import { COMPLAINT_TYPE } from '../../../../constants';
import { ReportInfo } from '../ReportInfoRow';
import { IDS } from '../../../../constants/ids';
import Button from '../../../Button';
import styles from './styles.styl';

const translationsByType = {
  [COMPLAINT_TYPE.COMMUNITY]: 'reports.community.info',
  [COMPLAINT_TYPE.COMMENT]: 'reports.comment.info',
  [COMPLAINT_TYPE.POST]: 'reports.post.info',
};

export const ReportItemImpl = ({
  formatMessage,
  item: {
    realm: { logo, name, id } = {},
    reporter: { username, id: reporterId },
    reportable = {},
    reason = {},
    createdAt,
    type,
    status,
  } = {},
  onClick,
}) => {
  const { author } = reportable || {};
  const contentMessage = () => {
    switch (type) {
      case COMPLAINT_TYPE.COMMENT:
      case COMPLAINT_TYPE.POST: {
        const authorName = get(author, 'user.aliasName');
        const userId = get(author, 'user.id');
        const community = <Link to={`/${COMMUNITIES}/${id}`}>{name}</Link>;
        const user = (
          <Link to={`/${PUBLIC_PROFILE}/${userId}`}>{authorName}</Link>
        );

        return (
          <FormattedMessage
            id={translationsByType[type]}
            values={{ user, community }}
          />
        );
      }

      case COMPLAINT_TYPE.COMMUNITY: {
        return (
          <FormattedMessage
            id="reports.community.info"
            values={{
              user: (
                <Link to={`/${PUBLIC_PROFILE}/${reporterId}`}>{username}</Link>
              ),
            }}
          />
        );
      }
    }
  };

  return (
    <CommunityCard
      avatar={{
        src: get(logo, 'thumbMin'),
        size: 80,
        name,
      }}
      renderTitle={() => name}
      renderContent={() => contentMessage()}
      renderActions={() => (
        <Button
          id={IDS.REPORTS.SEE_DETAILS_BTN}
          onClick={onClick}
          color="accent"
          border
        >
          {formatMessage({ id: 'reports.seeDetails' })}
        </Button>
      )}
      renderInfo={() => (
        <ReportInfo
          formatMessage={formatMessage}
          type={type}
          status={status}
          createdAt={createdAt}
          reason={reason}
          showDangerTitle
        />
      )}
    />
  );
};

export const ReportItem = compose(CSSModules(styles, { allowMultiple: true }))(
  ReportItemImpl,
);
const propTypes = {
  item: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
};
ReportItemImpl.propTypes = { ...ReportItemImpl };
ReportItem.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportItem/index.jsx